import { render, staticRenderFns } from "./MaterialTypeCellEditor.vue?vue&type=template&id=2bfa15ab"
import script from "./MaterialTypeCellEditor.vue?vue&type=script&lang=js"
export * from "./MaterialTypeCellEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports